/**
 * The one loading indicator in the app.
 *
 * A spinner rather than the word "Loading", because the session and content fetches
 * both resolve fast on a warm cache — a line of text that appears and vanishes reads
 * as a flicker, while a moving ring reads as work in progress. It is announced to
 * screen readers through the live region, which is what carries the meaning for anyone
 * who cannot see it turn.
 *
 * `full` fills the viewport, for the pre-shell states in App; the default sits inside
 * whatever panel is waiting, which is what the admin console needs.
 */
export function Loading({ label = 'Loading', full = false }: { label?: string; full?: boolean }) {
  return (
    <div className="vu-loading" data-full={full || undefined} role="status" aria-live="polite">
      <span className="vu-spinner" aria-hidden="true" />
      <span className="sr-only">{label}…</span>
    </div>
  );
}
